module.exports = __webpack_public_path__ + "img/spoken_read_stop.1310f0e2.svg";